import constants from "@core/config/constants";
export default {
  status: constants.STATUS,
  filters: {
    all: { name: 'All', value: 'all' },
    modified: { name: 'Recently Modified', value: 'modified' },
    draft: { name: 'Draft', value: 'draft' },
    scheduled: { name: 'Scheduled', value: 'scheduled' },
    sent: { name: 'Sent', value: 'sent' },
    ab_test: { name: 'A/B Campaigns', value: 'ab_test' },
    recurring: { name: 'Recurring', value: 'recurring' },
  },
  preferenceFilters: {
    all_page_types: { name: 'All Page Types', value: '' },
    manage_subscriptions: { name: 'Manage Subscriptions', value: 'manage_subscriptions' },
    edit_profile: { name: 'Edit Profile', value: 'edit_profile' },
    one_click_unsubscribe: { name: '1-Click Unsubscribe', value: 'one_click_unsubscribe' },
    report_spam: { name: 'Report Spam', value: 'report_spam' },
    thank_you_page: { name: 'Thank You Page', value: 'thank_you_page' },
    confirm_subscription: { name: 'Confirm Subscription', value: 'confirm_subscription'}
  },
  contact_filters: {
    all: { name: 'All', value: 'all' },
    subscribed: { name: 'Subscribed', value: 'subscribed' },
    unsubscribed: { name: 'Unsubscribed', value: 'unsubscribed' },
    hard_bounced: { name: 'Hard bounced', value: 'hard_bounced' },
    soft_bounced: { name: 'Soft bounced', value: 'soft_bounced' },
    cleansed: { name: 'Cleansed', value: 'cleansed' },
  },  
  uid_contact_filters: {
    all: { name: 'All', value: 'all' },
    EmailSubscribed: { name: 'Email Subscribed', value: 'email_subscribed' },
    EmailUnsubscribed: { name: 'Email Unsubscribed', value: 'email_unsubscribed' },
    SmsSubscribed: { name: 'SMS Subscribed', value: 'sms_subscribed' },
    SmsUnsubscribed: { name: 'SMS Unsubscribed', value: 'sms_unsubscribed' },
    hard_bounced: { name: 'Hard bounced', value: 'hard_bounced' },
    soft_bounced: { name: 'Soft bounced', value: 'soft_bounced' },
    cleansed: { name: 'Cleansed', value: 'cleansed' },
  },  
  sms_contact_filters: {
    all: { name:'All', value: 'all'},
    subscribed: { name: 'Subscribed', value: 'subscribed' },
    unsubscribed: { name: 'Unsubscribed', value: 'unsubscribed' },
  },
  journey_filters: { all: { name: 'All', value: 'all' }, modified: { name: 'Recently Modified', value: 'modified' }, draft: { name: 'Draft', value: 'draft' }, enabled: { name: 'Enabled', value: 'enabled' }, disabled: { name: 'Disabled', value: 'disabled' } },
  dateformatList: [
    {
      name: 'DD-MM-YYYY',
      value: '%d-%m-%Y',
    },
    {
      name: 'DD-MM-YY',
      value: '%d-%m-%y',
    },
    {
      name: 'MM-DD-YYYY',
      value: '%m-%d-%Y',
    },
    {
      name: 'YYYY-MM-DD',
      value: '%Y-%m-%d',
    },
    {
      name: 'DD/MM/YYYY',
      value: '%d/%m/%Y',
    },
    {
      name: 'MM/DD/YYYY',
      value: '%m/%d/%Y',
    },
    {
      name: 'dd.mm.yyyy',
      value: '%d.%m.%Y',
    },
    {
      name: 'DD/MM/YY',
      value: '%d/%m/%y',
    },
    {
      name: 'MM/DD/YY',
      value: '%m/%d/%y',
    },
    {
      name: 'YYYY/MM/DD',
      value: '%Y/%m/%d',
    },
    {
      name: 'YYYYMMDD',
      value: '%Y%m%d',
    },
  ],
  contact_status: {
    Subscribed: {
      color: '#41CE65',
    },
    Unsubscribed: {
      color: '#E02020',
    },
    'Soft-Bounced': {
      color: '#826AF9',
    },
    'Hard-Bounced': {
      color: '#707376',
    },
    Ok: {
      color: '#41CE65',
    },
    Complained: {
      color: '#E02020',
    },
    Cleansed: {
      color: '#41CE65',
    },
    Workflow: {
      color: '#FFBF4A',
    }
  },
  color_code:{
    blue_icon: '#45b6f8'
  },
  content_type: {
    all: { name: 'All', value: 'all' },
    wysiwyg: { name: 'WYSIWYG', value: '0' },
    dndlegacy: { name: 'DnD (Legacy)', value: '1' },
    html: { name: 'HTML code editor', value: '2' },
    pullfromurl: { name: 'Pull from URL', value: '3' },
    dnd: { name: 'DnD', value: '4' },
    dndbeta: { name: 'DnD (Beta)', value: '5' },
  },
  /**
   * Adding new constant to be used in preference management index as we removed DnD legacy, Pull from URL & DnD from content_type
   */
  preference_editor_types: [
    { name: 'All Editor Types', value: 'all' },
    { name: 'Drag & Drop', value: '5' },
    { name: 'WYSIWYG', value: '0' },
    { name: 'HTML Code Editor', value: '2' },
  ],
  /**
   * Adding new constant to be used in email content index as we removed DnD legacy from content_type
   */
  CONTENT_EDITOR_TYPES: {
    all: { name: 'All', value: 'all' },
    dnd: { name: 'Drag & Drop', value: '5' },
    wysiwyg: { name: 'WYSIWYG', value: '0' },
    html: { name: 'HTML Code Editor', value: '2' },
    pullfromurl: { name: 'Pull from URL', value: '3' },
    /**
     * Ref: ANC-1820
     * Drag and Drop editor(DnD > created using the GrapesJS free plug-in) has been kept for around 2 years
     * in the drop down of Email Content now but it is not being used by any of the users.
     * So deprecating DnD option from the filter and use DND beta as DnD
     */
    // dnd: { name: 'DnD', value: '4' },
    // dndbeta: { name: 'DnD', value: '5' },
  },
   /**
   * Chip colors
   */
    CHIP_COLORS: {
      blue: "#cce1ef"
    },
    indexPageWidth:{
      nameMinimumWidth:180,
      dateMinimumWidth:135,
      dateMaximumWidth:230
    },
    /**
     * Sorting orders od the table records
     */
     SORTING_ORDERS: {
      asc: "asc",
      desc: "desc"
    },
    /**
     * Sms status chip colors
     */
    SMS_STATUS_CHIP_COLORS: {
      delivered: "#41CE65",
      sent: "#03B6FC",
      failed: "#BA031A"
    },
    /**
     * Api response codes
     * @description Use these response codes in api request to check the status of a http request
     */
    RESPONSE_CODES: {
      serverError: 500,
      success:200,
      forbidden:403,
      notFound:404
    },
    mobileResponsiveFilters:{
      formatDate:'formatDate',
      currency:'currency',
      currenyCent:'currenyCent'
    },
    COMMON_ERROR_MESSAGE: "Server request timed out.",
    DEFAULT_ERROR_MESSAGE: "Something went wrong.",
    IDENTITY_ERROR_MESSAGE:"User requires 2FA",
    IDENTITY_STAGING_JTI_COOKIE_NAME :'_mp_jti_staging',
    IDENTITY_STAGING_USER_PROFILE_COOKIE_NAME :'_mp_user_profile_staging',
    DND_EDITOR_TEMPLATES: [{ id: 0, name: 'Basic Template', url: require('@/assets/basic_template.jpg') }, { id: 1, name: 'Template Image Left', url: require('@/assets/template_left.jpg') },
    { id: 2, name: 'Template Image Right', url: require('@/assets/template_right.jpg') }, { id: 3, name: 'Template With Header', url: require('@/assets/template_with_header.jpg') },
    { id: 4, name: 'Grid Template', url: require('@/assets/grid_template.jpg') }, { id: 5, name: 'Blank Template', url: require('@/assets/blank_template.png') }],
    /**
     * Identity error codes
     * @description These codes act as an identitfier for login cases
     */
    IDENTITY_AUTH_ERROR_CODES : {
      userNotFound:"auth/maropost-user-not-found",
      accountNotFound:"auth/maropost-account-not-found"
    },
    /**
     * Emails
     */
    OFFICIAL_EMAILS:{
      SUPPORT_EMAIL: 'support@maropost.com',
      ACCOUNT_CHANGES_EMAIL: 'subscriptions@maropost.com',
      BILLING_EMAIL: 'billing@maropost.com'
    },
    /**
     * Language list 
     */
    LANGAUGE_LIST: [
      { name: 'English', value: 'en' },
      { name: 'Spanish', value: 'es' },
      { name: 'German', value: 'de' },
      { name: 'Italian', value: 'it' },
      { name: 'French', value: 'fr' },
      { name: 'Portuguese', value: 'pt' },
      { name: 'Polish', value: 'pl' },
      { name: 'Danish', value: 'da' },
      { value: 'zh', name: 'Chinese'},
      { name: 'Dutch', value: 'nl' },
      { name: 'Swedish', value: 'sv' },
      { name: 'Norwegian', value: 'no' }
    ],
    /**
     * form builder layout
     */
    FORM_BUILDER_LAYOUT:{
      checkboxColor: '#03B6FC',
      radioColor:'#03B6FC',
      sliderTrackColor: '#C9C9C9',
      sliderColor: '#303030',
      primaryColor:'#03B6FC',
      linkColor: '#006BAF',
      tooltipColor:'rgba(0, 0, 0, 0.9)',
      positionOptions: [
        { text: "Classic center", value: "classic-center" },
        { text: "Classic top right", value: "classic-top-right" },
        { text: "Classic top left", value: "classic-top-left" },
        { text: "Classic bottom right", value: "classic-bottom-right" },
        { text: "Classic bottom left", value: "classic-bottom-left" },
        { text: "Drawer left", value: "drawer-left" },
        { text: "Drawer right", value: "drawer-right" },
        { text: "Bar bottom", value: "bar-bottom" },
        { text: "Bar top", value: "bar-top" }
      ],
    },
    acquisition:{
      chipColor: '#1E2533',
      stepperGreyColor:'rgba(0, 0, 0, 0.38)',
      popupKeyName:'display_popup',
      embeddedKeyName:'embedded_form',
      defaultTemplate:'create_from_scratch'
    },
    
    ORDER_STATUS: constants.ORDER_STATUS,
    /**
     * SMS link tracking domains
     * @description These tracking domains are used in sms campaigns
     * they replace the env url with keywords
     */
    click_tracking: {
      urlRegex: new RegExp(/((http|https):\/\/|www)[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}/)
    },
    DATE_PICKER: {
      color:"#03B6FC"
    },
    SMS_BUILDER:{
      icon_color:"#8b8b8b"
    },
    BUTTON_COLOR: {
      text: '#FFFF',
      background: '#8b8b8b',
      primaryColor: '#00b7ff',
    },
    SELECT_COLOR: {
      itemColor: '#03B6FC',
    },
    TOOLTIP_COLOR: {
      background: '#000000e6',
    },
    CARD_COLOR: {
      text: '#FEE28E',
      background: '#000000de',
      primaryText: '#EFC5CA',
      primaryColor: '#B00020',
    },
    ICON_COLOR: {
      color: '#00000099',
      primaryColor: '#B00020',
    },
    RADIO_COLOR: {
      color: '#03b6fc',
    },
    TAB_COLOR: {
      color: '#fafafa',
    },
    TABS_COLOR: {
      color: '#03b6fc',
    },
    CHECKBOX_COLOR: {
      color: '#03b6fc',
    },
    RECURRING_TIME: [
      { id: 1, name: 'Day' },
      { id: 2, name: 'Week' },
      { id: 3, name: 'Month' },
      { id: 4, name: 'Year' },
    ],
    MAROPOST_PRODUCTS:{
      marketingCloud:"marketing_cloud",
      serviceCloud:"service_cloud"
    },
    PRODUCT_IDENTFIERS: {
      mmc: { id: "mmc", type: "emails" },
      msc: { id: "msc", type: "ticket" }
    },
    USAGE_CHART_COLORS:{
      usage:"#03B6FC",
      pending:"#CDF0FE",
      overage:"#F3425C"
  },
    FOOTER_PROPS:{
      'items-per-page-options': [5, 10, 25, 50, 100]
    },
    THANK_YOU_PAGE: "thank_you_page",
    SPLIT_IO_KEYS:{
      isUIDAccount : 'uid_changes',
      findifyRecommendation:'findify_recommendation_bought_together',
      erfmSettings:'eRFM_Settings'
    }
};
